import React from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

export default function CustomPopoverTypography({ title, children, ...props }) {
  return (
    <>
      <Box display="flex">
        <Typography
          align="left"
          color="primary"
          variant="h6"
          {...props}
        >
          {title}:
        </Typography>
        &nbsp;
        <Typography
          align="left"
          color="textSecondary"
          variant="h6"
          {...props}
        >
          {children}
        </Typography>
      </Box>
    </>
  );
};
